export enum SubscriptionStatusType {
    // error // in_progress // cancelled // paused
    ERROR = 'error',
    IN_PROGRESS = 'in_progress',
    CANCELLED = 'cancelled',
    PAUSED = 'paused',
}
